import * as React from "react";
import {FormComponentProps} from "../../form/Form";
import {TournamentConstraints, IntConfigConstraint} from "../../../../generated/protocol";
import {FormGroup} from "../../form/FormGroup";
import {FormInput} from "../../form/FormInput";
import {FormTransferContainer} from "../../form/FormTransferContainer";
import {SelectInput} from "../../form/SelectInput";
import {Validators, Validator} from "../../form/Validators";
import {FeatureToggleService} from "../../../service/FeatureToggleService";

interface Props extends FormComponentProps {
    constraints?: TournamentConstraints;
    sitAndGo?: boolean;
    canHaveLateReg?: boolean;
}

const maxPlayersConstraint = {
    min: 2,
    max: 5000,
};

export class PokerGameSettingsPanel extends React.Component<Props, {}> {


    getIdValue(idVal: { id: number }) {
        return idVal.id;
    }

    getNameValue(nameVal: { name: string }) {
        return nameVal.name;
    }

    render() {
        var constraints = this.props.constraints;
        return (
            <FormTransferContainer {...this.props} model="configuration">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">
                            <div className="ibox-title">
                                <h5>Poker Game Settings</h5>
                            </div>
                            <div className="ibox-content">
                                <FormGroup className="form-group">
                                    <label className="col-sm-2 control-label">Variant</label>
                                    <div className="col-sm-10">
                                        <SelectInput className="form-control m-b" model="variant"
                                                     values={constraints.variants}/>
                                    </div>
                                </FormGroup>
                                <div className="hr-line-dashed"></div>

                                <FormGroup className="form-group">
                                    <label className="col-sm-2 control-label">Bet Strategy</label>
                                    <div className="col-sm-10">
                                        <SelectInput className="form-control m-b" model="betStrategy"
                                                     values={constraints.betStrategyTypes}/>
                                    </div>
                                </FormGroup>
                                <div className="hr-line-dashed"></div>

                                <FormGroup className="form-group">
                                    <label className="col-sm-2 control-label">Blinds Structure</label>
                                    <div className="col-sm-10">
                                        <SelectInput className="form-control m-b"
                                                     model="blindsStructureId"
                                                     values={constraints.blindsStructures}
                                                     displayValue={this.getNameValue.bind(this)}
                                                     optionModelValue={this.getIdValue.bind(this)}/>
                                    </div>
                                </FormGroup>

                                <div className="hr-line-dashed"/>

                                { getSynchrinizeBreaksOption(this.props.sitAndGo) }

                                <FormGroup className="form-group">
                                    <label className="col-sm-2 control-label">Starting Chip Stack</label>
                                    <div className="col-sm-10">
                                        <FormInput type="float" model="startingChips"
                                                   validators={Validators.bigDecimalConstraint(constraints.startingChips)}
                                                   className="form-control"/>
                                        <span className="help-block m-b-none">Amount of chips to start the tournament with</span>
                                    </div>
                                </FormGroup>

                                <div className="hr-line-dashed"></div>

                                {this.props.canHaveLateReg &&
                                <div>
                                    <FormGroup className="form-group">
                                        <label className="col-sm-2 control-label">Late Registration Level</label>
                                        <div className="col-sm-10">
                                            <FormInput type="text" model="lateRegistrationLevel"
                                                       className="form-control" />
                                            <span className="help-block m-b-none">
                                            Highest blinds level where late registration is possible.
                                            <strong>NOTE: First level is 0.</strong> Set to -1 to disable late registration.
                                        </span>
                                        </div>
                                    </FormGroup>

                                    <div className="hr-line-dashed"></div>
                                </div>
                                }

                                <FormGroup className="form-group">
                                    <label className="col-sm-2 control-label">Timing Profile</label>
                                    <div className="col-sm-10">
                                        <SelectInput className="form-control m-b" model="timingTypeId"
                                                     values={constraints.timingProfiles}
                                                     displayValue={this.getNameValue}
                                                     optionModelValue={this.getIdValue}/>
                                    </div>
                                </FormGroup>

                                <div className="hr-line-dashed"></div>

                                <FormGroup className="form-group">
                                    <label className="col-sm-2 control-label">Chess Clock</label>
                                    <div className="col-sm-10">
                                        <FormInput type="checkbox" model="chessClock"/>
                                    </div>
                                </FormGroup>

                                <div className="hr-line-dashed"></div>

                                <FormGroup className="form-group" model="minPlayers">
                                    <label className="col-sm-2 control-label">Min Players</label>
                                    <div className="col-sm-10">
                                        <FormInput type="text" model="minPlayers"
                                                   validators={Validators.intConstraint(constraints.minPlayers)}
                                                   className="form-control"/>
                                        <span className="help-block m-b-none">The minimum number of players that are are required for this tournament to start</span>
                                    </div>
                                </FormGroup>

                                <div className="hr-line-dashed"></div>

                                {!this.props.sitAndGo &&
                                <div>
                                    <FormGroup className="form-group">
                                        <label className="col-sm-2 control-label">Max Players</label>
                                        <div className="col-sm-10">
                                            <FormInput type="text" model="maxPlayers"
                                                       validators={Validators.intConstraint(maxPlayersConstraint)}
                                                       className="form-control"/>
                                            <span className="help-block m-b-none">The maximum number of players that are allowed to register. Value cannot be greater than {maxPlayersConstraint.max}. Based on past experience the system cannot support tournaments larger than this.</span>
                                        </div>
                                    </FormGroup>
                                    <div className="hr-line-dashed"></div>
                                </div>
                                }


                                <FormGroup className="form-group">
                                    <label className="col-sm-2 control-label">Seats per table</label>
                                    <div className="col-sm-10">
                                        <FormInput type="text" model="seatsPerTable"
                                                   validators={Validators.intConstraint(constraints.seatsPerTable)}
                                                   className="form-control"/>
                                        <span className="help-block m-b-none">How many players that can be seated at a single table</span>
                                    </div>
                                </FormGroup>

                                <div className="hr-line-dashed"></div>

                            </div>
                        </div>
                    </div>
                </div>
            </FormTransferContainer>
        );

    }


}

function getSynchrinizeBreaksOption(isSitAndGo: boolean): JSX.Element | null {
    if (isSitAndGo) return;
    if (!FeatureToggleService.synchedBreaksFeatureFlag.isEnabled) return;

    return <div>
        <FormGroup className="form-group">
            <label className="col-sm-2 control-label">Synchronized Breaks</label>
            <div className="col-sm-10">
                <FormInput type="checkbox" model="synchronizeBreaks"/>
                <span className="help-block m-b-none">Tournament will break for 5 minutes each hour at 55 minutes past the hour.</span>
            </div>
        </FormGroup>
        <div className="hr-line-dashed"/>
    </div>;
}


// WEBPACK FOOTER //
// ./src/app/ui/poker/tournament/PokerGameSettingsPanel.tsx